import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Checkbox from "components/forms/inputs/checkbox";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { showError, showSuccess } from "lib/notification";
import { List } from "models/list";
import { FunctionComponent, useState } from "react";
import { useForm } from "react-hook-form";
import { adminDoPatchList } from "services/admin/list";
import { fetchAdminList } from "stores/actions/list";
import { fetchLists } from "stores/actions/lists";
import * as yup from "yup";
import ListSchemaTable from "components/list/list-schema-table";
import { SchemaColumn } from "models/generic";
import { faSave } from "components/icon-library";

interface SettingsListFormProps {
  list: List;
}

const SettingsListForm: FunctionComponent<SettingsListFormProps> = ({
  list,
}) => {
  const [listSchema, toggleListSchema] = useState<SchemaColumn[]>(list.schema);

  // build validation schema based on fields
  const schema = yup.object({
    name: yup.object().validateLocaleString(),
    closed: yup.bool(),
    archived: yup.bool(),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: list.name,
      closed: list.closed,
      archived: list.archived,
    },
  });

  const handleSubmit = async (values: any) => {
    const { name, closed, archived } = values;
    try {
      // save changes
      await adminDoPatchList(list, {
        name,
        closed,
        archived,
        schema: listSchema,
      });

      // update a few things
      fetchAdminList(list.uuid);
      fetchLists();

      // notify
      showSuccess("Tallentaminen onnistui.");
    } catch (err) {
      showError("Tallentaminen epäonnistui.");
    }
  };

  const buttons: FormButtonInterface[] = [
    {
      ...SubmitButton,
      text: "Tallenna asetukset",
      align: "left",
      postIcon: faSave,
    },
  ];
  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextInput
              name="name"
              translations
              label="Luettelon nimi"
              required
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              name="closed"
              label="Luettelo suljettu ja ilmoitusvelvollisten pääsy luotteloon on estetty."
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              name="archived"
              label="Luettelo arkistoitu ja sen näkyvyys on rajoitettua."
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ListSchemaTable
              list={list}
              schema={listSchema}
              onUpdate={async (schema) => {
                toggleListSchema([...schema]); // create new instance
              }}
            />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default SettingsListForm;
